// extracted by mini-css-extract-plugin
export default {"link":"yJ-z","disabled":"zJ-z"};